import type { ActionResponse } from '../DTOs/Common/ErrorResponse'
import { isOnlineNow } from './connectivity'
import { mayQueueOffline, offlineRefusal } from './offlineWrites'

export type Queued<T> = ActionResponse<T | null> & { queued?: boolean }

export const queued = <T>(data: T): Queued<T> => ({ success: true, data, queued: true })

// Note: a save that went out but got no reply may or may not have reached the server, so rather than being
// lost it is queued under the id it was sent with. The server records that id when it applies a direct save
// and the sync endpoint skips an id it has recorded, so a save that did arrive is not applied twice. A reply
// of any kind, an error included, resolves rather than rejects, so only a missing reply falls through.
export async function sendDirect<T>(send: () => Promise<T>): Promise<T | null> {
  try {
    return await send()
  } catch {
    return null
  }
}

export async function sendFirst<T>(send: () => Promise<T>, online = isOnlineNow()) {
  if (online) {
    const reply = await sendDirect(send)
    if (reply) return { reply, sentDirect: true }
  }
  return { reply: mayQueueOffline() ? null : offlineRefusal(), sentDirect: online }
}
